//========================== 상수 =================

import store from '@/store/store';
import securityInfo from './cryptoUtils';
import alertMsg from './toastUtils';

import hostConfig from '@/config/hostConfig';
import localeConfig from '@/config/localeConfig';

// project code 변할일이 없다 -> 1 : CRK IoT
export const PROJECT_CODE = 1;
export const MOBILE_SIZE = 600; //모바일사이즈
export const TABLET_SIZE = 1280; //테블릿가로사이즈

export const videoAllowedBoardTypes = [2, 7, 6]; // 2: 교육자료, 7: 기술공유방, 6: 기술공지
export const readonlyBoardTypes = [5]; // 5: 일반공지 추가, 편집 불가(읽기만 가능))

export const readableBoardTypeInMobile = [6, 10]; // 모바일에서 볼 수 있는 board Type
export const remInPx = window.getComputedStyle(
  document.documentElement
).fontSize; // 픽셀 당 rem 단위

export const excludeMobileMenuCodes = ['080101', '080103', '080104', '080102']; // 080101: 제품 분석, 080103: 서비스 분석, 080104: 설치 분석, 080102: 알람 분석
// export const TABLET_HEIGHT_SIZE = 980 // 테블릿 세로사이즈

//============================함수 ================

/**
 * Null 체크
 * 2024.02.28 - Saylee
 * @param {*} value Null 체크값
 * @returns
 */
export const nullCheck = (value) => {
  return (
    value === '' ||
    value === null ||
    value === undefined ||
    (typeof value === 'object' && !Object.keys(value).length)
  );
};

/**
 * 값이 비어있으면 null, 아니면 정수로 변환
 * - '', null, undefined => null
 * - 숫자로 변환 불가(NaN) => null
 */
export const toIntOrNull = (value) => {
  if (value === '' || value === null || value === undefined) return null;
  const n = parseInt(value, 10);
  return Number.isNaN(n) ? null : n;
};

export const objectNullCheck = (value) => {
  // value === '' || value === null || value === undefined || (typeof value === 'object' && !Object.keys(value).length)
  if (Object.keys(value).length > 0) {
    let cnt = 0;
    Object.keys(value).forEach((key) => {
      if (!nullCheck(value[key])) {
        cnt += 1;
      }
    });

    return cnt > 0 ? false : true;
  } else {
    if (
      value === '' ||
      value === null ||
      value === undefined ||
      (typeof value === 'object' && !Object.keys(value).length)
    ) {
      return true;
    }
  }
  return false;
};

/**
 * 숫자 3자리씩 표기
 * 2024.02.28 - Saylee
 * @param {*} value 숫자
 * @returns
 */
export const addComma = (price) => {
  let returnString = price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return returnString;
};

export const isUseText = (isUse) => {
  let isUseText = '미사용';
  if (isUse) {
    isUseText = '사용';
  }
  return isUseText;
};

/**
 * 현재날짜 String 으로 return
 */
export const currentDateString = (date) => {
  // Date 객체 생성

  let dateObject = new Date();

  // 원하는 형식으로 날짜 형식화
  let formattedDate =
    dateObject.getFullYear() +
    '-' +
    ('0' + (dateObject.getMonth() + 1)).slice(-2) +
    '-' +
    ('0' + dateObject.getDate()).slice(-2) +
    ' ' +
    ('0' + dateObject.getHours()).slice(-2) +
    ':' +
    ('0' + dateObject.getMinutes()).slice(-2) +
    ':' +
    ('0' + dateObject.getSeconds()).slice(-2);
  return formattedDate;
};

/**
 * 현재 월의 첫번째 일자 구해오기
 * format: 2024-01-01
 */
export const getCurrentMonthStartDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const formattedMonth = (month + 1).toString().padStart(2, '0');
  const formattedDate = `${year}-${formattedMonth}-01`; //시작일자
  return formattedDate;
};

/**
 * 현재 년월
 * format: 2024-01
 */
export const getCurrentYearMonth = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const formattedMonth = (month + 1).toString().padStart(2, '0');
  const formattedDate = `${year}-${formattedMonth}`; //시작일자
  return formattedDate;
};

/**
 * 현재 월의 마지막 일자 구해오기
 * format: 2024-01-31
 */
export const getCurrentMonthEndDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const formattedMonth = (month + 1).toString().padStart(2, '0');
  const lastDayOfMonth = new Date(year, month + 1, 0).getDate();
  const formattedDate = `${year}-${formattedMonth}-${lastDayOfMonth}`;
  return formattedDate;
};

/**
 * 월의 마지막 일자 구해오기
 * format: 2024-01-31
 */
export const getMonthEndDate = (yearMonth) => {
  const now = new Date(yearMonth);
  const year = now.getFullYear();
  const month = now.getMonth();
  const formattedMonth = (month + 1).toString().padStart(2, '0');
  const lastDayOfMonth = new Date(year, month + 1, 0).getDate();
  const formattedDate = `${year}-${formattedMonth}-${lastDayOfMonth}`;
  return formattedDate;
};

/**
 * 특정 날짜(date)를 String 으로 return
 * @param {*} date  //필수
 * @returns
 */
export const specificDateString = (date) => {
  let dateObject = date;

  // 원하는 형식으로 날짜 형식화
  let formattedDate =
    dateObject.getFullYear() +
    '-' +
    ('0' + (dateObject.getMonth() + 1)).slice(-2) +
    '-' +
    ('0' + dateObject.getDate()).slice(-2) +
    ' ' +
    ('0' + dateObject.getHours()).slice(-2) +
    ':' +
    ('0' + dateObject.getMinutes()).slice(-2) +
    ':' +
    ('0' + dateObject.getSeconds()).slice(-2);
  return formattedDate;
};

/**
 * 두날짜 사이 일수 계산
 * @param {*} date
 * @returns
 */
export const getDateDiff = (d1, d2) => {
  const date1 = new Date(d1);
  const date2 = new Date(d2);
  const diffDate = date1.getTime() - date2.getTime();
  return Math.abs(diffDate / (1000 * 60 * 60 * 24)); // 밀리세컨 * 초 * 분 * 시 = 일
};

/**
 * 셀렉트박스에 필요한 list로 바꾸기
 * @param {*} selectList
 * @returns
 */
export const convertSelectListToMap = (selectList) => {
  const result = {};
  if (selectList) {
    selectList.forEach((item) => {
      result[item.value] = item.label;
    });
  }
  return result;
};

/**
 * 2024.06.14 -- Saylee
 * 고유한 UUID 생성  -> 하이푼 없이  (하이푼 빼야함 파일업로드처리정책시 하이푼없이사용중임)
 * @returns
 */
export const generateUUID = () => {
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * 절대값 생성
 * @param {*} value number
 * @returns number
 */
export const absNum = (value) => {
  let num = value;
  if (value) {
    num = Math.abs(value);
  }
  return num;
};

/**
 *
 * @returns YYYYMM리턴
 */
export const getCurrentYYYYMM = () => {
  const date = new Date(); // 현재 날짜와 시간을 나타내는 Date 객체 생성

  const year = date.getFullYear(); // 연도 가져오기
  let month = date.getMonth() + 1; // 월 가져오기 (0부터 시작하므로 1을 더해야 함)

  // 월이 1자리 숫자인 경우 앞에 0을 추가하여 두 자리 숫자로 만듦
  month = month < 10 ? '0' + month : month;

  const yyyymm = `${year}${month}`; // 연도와 월을 결합하여 YYYYMM 형식의 문자열 생성

  return yyyymm; // YYYYMM 문자열 반환
};

export const getCurrentTime = (isNotHypun) => {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1을 해줍니다.
  const date = String(now.getDate()).padStart(2, '0');

  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  if (isNotHypun) {
    return `${year}${month}${date}${hours}${minutes}${seconds}`;
  } else {
    return `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`;
  }
};

/**
 * 2024.07.17 saylee
 * 파일저장시 파일이름은 uuid(-제거) + HHMMSSMS
 */
export const getFileName = () => {
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  const milliseconds = String(now.getMilliseconds()).padStart(2, '0');
  const uuid = generateUUID();
  return `${uuid}${hours}${minutes}${seconds}${milliseconds}`;
};

/**
 * 2024.07.17 saylee
 * 파일 확장자로 s3에 올릴 경로 추출  (펌웨어 ,제품의 모델 이미지 부품이미지 는 해당 함수 쓰지말고  별도로 지정해서 쓰세요.)
 */
export const getFileDir = (fileExt) => {
  let destination;

  // 확장자에 따라 경로 설정
  //
  if (['jpg', 'jpeg', 'png', 'gif', 'pdf'].includes(fileExt.toLowerCase())) {
    destination = 'images';
  } else if (['mp4', 'avi', 'mov', 'wmv'].includes(fileExt.toLowerCase())) {
    destination = 'videos';
  } else {
    destination = 'files';
  }

  return destination;
};

export const getFileType = (fileExt) => {
  let type;

  if (['jpg', 'jpeg', 'png', 'gif', 'pdf'].includes(fileExt.toLowerCase())) {
    type = 'images';
  } else if (['mp4', 'avi', 'mov', 'wmv'].includes(fileExt.toLowerCase())) {
    type = 'video';
  } else {
    type = 'file';
  }

  return type;
};

/**
 * 2024.07.17 saylee
 * fileurl(Objectkey) 생성
 * //(펌웨어 ,제품의 모델 이미지 부품이미지 는 해당 함수 쓰지말고  별도로 지정해서 쓰세요.)
 * @param {*} fileExt
 * @returns
 */
export const getFileUrl = (fileExt) => {
  if (!fileExt) return '';

  let fileDir = getFileDir(fileExt);
  let yyyymm = getCurrentYYYYMM();
  let fileName = getFileName();

  return `files/${fileDir}/${yyyymm}/${fileName}.${fileExt}`; //objectkey
};

/**
 * 디렉토리명이 들어가는 파일 url 생성
 * @param {*} dirnm
 * @param {*} fileExt
 * @returns
 */
export const getDirectoryFileUrl = (dirnm, fileExt) => {
  if (!fileExt) return '';

  // let fileDir = getFileDir(fileExt);
  let yyyymm = getCurrentYYYYMM();
  let fileName = getFileName();

  return `files/${dirnm}/${yyyymm}/${fileName}.${fileExt}`; //objectkey
};

/**
 * 2024.07.18  - saylee
 * Select Box Option이 닫히면   포커스 blur처리
 * 모바일시 키패드 닫히도록 하기위함
 */
export const handleActiveBlur = (isClose) => {
  // settimeout 을 0.0001초 두어서 브라우저에상관없이 작동하도록..
  if (!isClose) {
    setTimeout(function () {
      var focusedElement = document.activeElement;
      if (focusedElement) {
        focusedElement.blur();
      }
    }, 1);
  }
};

/**
 * 2024.08.28  - jslee
 * el-autocomplete 값 select되면 포커스 blur처리
 * 모바일시 키패드 닫히도록 하기위함
 */
export const handleActiveBlurForAutoComplete = () => {
  // settimeout 을 0.0001초 두어서 브라우저에상관없이 작동하도록..
  setTimeout(function () {
    var focusedElement = document.activeElement;
    if (focusedElement) {
      focusedElement.blur();
    }
  }, 1);
};

/**
 * 2024-07-22 saylee
 * 웹뷰로 접근했는지 아닌지 (모바일 기기에서도 , 브라우저로 들어왔는지, 웹뷰로들어왔는지 체크할경우사용하시오.)
 * return ( 브라우저로 접근했으면 browser  , 안드로이드 웹뷰면 androidWebView , IOS 웹뷰면 iosWebView    )
 */
export const getCheckWebView = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  let result = 'browser';

  // Check if the user agent indicates Android WebView
  const isAndroid = /Android/.test(userAgent);
  const isLatestAndroidTablet =
    /Linux/.test(userAgent) && navigator.maxTouchPoints > 0; //비교적 최신 태블릿(ex: s7 fe)은 userAgent에 Android빠지는 경우 있음

  const isWebView = /CRK-SQUARE/.test(userAgent);
  // Check if the user agent indicates iOS WebView
  let isIOS = /iPhone|iPad|iPod/.test(userAgent);
  //최근 아이패드는 os가 mac으로 찍혀서 maxTouchPoints 로 구분한다.
  if (navigator.maxTouchPoints > 0) {
    isIOS = true;
  }

  if ((isAndroid || isLatestAndroidTablet) && isWebView) {
    result = 'androidWebView';
  } else if (isIOS && isWebView) {
    result = 'iosWebView';
  }

  return result;
};

// export const getCheckBrowserAn = () => {

// }

/**
 * 2024-07-22 leejingyeong
 * OS 판별 (android/ios)
 */
export const getCheckAndroidIOS = () => {
  const value = navigator.userAgent.toLocaleLowerCase();
  let result = '';
  if (
    value.indexOf('iphone') > -1 ||
    value.indexOf('ipad') > -1 ||
    value.indexOf('ipod') > -1
  ) {
    result = 'ios';
  } else {
    result = 'android';
  }
  return result;
};

/**
 * 2024-07-22 leejingyeong
 * 모바일/태블릿/PC 판별 (ios/android/windows mobile/tablet/pc)
 */
export const getCheckDeviceOS = () => {
  const value = navigator.userAgent.toLocaleLowerCase();

  const os = getOS();

  let result = '';
  if (value.indexOf('iphone') > -1 || value.indexOf('ipod') > -1) {
    result = 'ios';
  } else if (os === 'Mac OS') {
    if (navigator.maxTouchPoints > 1) {
      result = 'ipad';
    } else {
      result = 'mac';
    }
  } else {
    if (value.includes('mobile')) {
      // 모바일인 경우
      result = 'android';
    } else {
      if (os === 'Android' && navigator.maxTouchPoints > 1) {
        result = 'androidTab';
      } else {
        if (os === 'Windows') {
          result = 'windows';
        } else if (os === 'Linux') {
          if (navigator.maxTouchPoints > 1) {
            result = 'androidTab';
          } else {
            result = 'linux';
          }
        }
      }
    }
  }

  return result;
};

/**
 * 2024-07-31 leejingyeong
 * 터치 가능한 디바이스 확인 (모바일/태블릿 여부)
 */
export const getCheckIsMobileTabletDevice = () => {
  const os = getCheckDeviceOS();
  let result = false;
  if (
    os === 'ios' ||
    os === 'ipad' ||
    os === 'android' ||
    os === 'androidTab'
  ) {
    result = true;
  }
  return result;
};

const getOS = () => {
  var userAgent = window.navigator.userAgent;
  var platform = window.navigator.platform;
  var macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
  var windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
  var iosPlatforms = ['iPhone', 'iPad', 'iPod'];
  var os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (/Linux/.test(platform)) {
    os = 'Linux';
  }
  // console.log("OS")
  // alertMsg(os)
  return os;
};

/**
 * 전화번호 format
 * 8자리: 1234-1234
 * 10자리: 02-1234-1234 / 031-123-1234
 * 11자리: 010-1234-1234
 */
export const formatTelno = (value) => {
  let formattedTel = '';
  if (value) {
    if (value.length === 8) {
      formattedTel = `${value.substring(0, 4)}-${value.substring(4)}`;
    }
    if (value.length === 10) {
      if (value.startsWith('02')) {
        formattedTel = `${value.substring(0, 2)}-${value.substring(
          2,
          6
        )}-${value.substring(6)}`;
      } else {
        formattedTel = `${value.substring(0, 3)}-${value.substring(
          3,
          6
        )}-${value.substring(6)}`;
      }
    }
    if (value.length === 11) {
      formattedTel = `${value.substring(0, 3)}-${value.substring(
        3,
        7
      )}-${value.substring(7)}`;
    }
  }

  return formattedTel;
};

/**
 * 날짜 문자열 포맷 변경
 * @value 포맷 변경전 데이트피커에서 가져오는 날짜 ex) 20240101
 * @return 포맷 변경된 날짜 ex) 2024-01-01
 */
export const formatYyyymmdd = (value) => {
  let yyyymmdd = '';
  if (typeof value === 'string') {
    yyyymmdd = `${value.substring(0, 4)}-${value.substring(
      4,
      6
    )}-${value.substring(6)}`;
  }
  return yyyymmdd;
};

/**
 * IoT 모듈 F/W 버전 표기를 사용자 친화적으로 변환
 * - prefix 기본값: "8.2."
 * - "0.18" -> "8.2.1.8"
 * - 이미 "8.2."로 시작하면 그대로 반환
 */
export const formatIotModuleFwVersion = (raw, fixedPrefix = '8.2.') => {
  if (raw === null || raw === undefined || raw === '') return '-';

  const rawStr = String(raw).trim();
  if (rawStr === '') return '-';

  if (fixedPrefix && rawStr.startsWith(fixedPrefix)) return rawStr;

  const m = rawStr.match(/^0\.(\d+)$/);
  if (m) {
    const digits = m[1];
    return `${fixedPrefix}${digits.split('').join('.')}`;
  }

  return `${fixedPrefix}${rawStr}`;
};

/**
 * 데이트 피커 시작일로부터 선택 가능 날짜 범위를 벗어나는지 확인
 * @startDate 시작일자 ex) 2024-08-01
 * @endDate 종료일자 ex) 2024-08-07
 * @maxDaysFromStart 시작일로부터 최대 허용 일수
 * @return 시작일로부터 종료일자가 최대 허용 일수에 속하는지 여부
 */
export const checkDateInRange = (startDate, endDate, maxDaysFromStart) => {
  const maxDate =
    new Date(startDate).getTime() + maxDaysFromStart * 24 * 60 * 60 * 1000; // 시작일로부터 7일 후
  if (new Date(endDate).getTime() > maxDate) {
    return false;
  }
  return true;
};

/**
 *
 * @startDate 시작일자 ex) 2024-08-01
 * @endDate 종료일자 ex) 2024-08-07
 * @return 시작일자와 종료일자가 현재 일자 범위보다 큰지 여부
 */
export const checkDateInPastOrToday = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  let now = new Date();

  if (start > now || end > now) {
    return false;
  }
  return true;
};

/**
 * 2024.10.09 - leejingyeong
 * 일자 데이터 변환하는 함수
 * YYYY-MM-DD HH:mm:ss 양식을 YYYYMMDD 양식으로 변경
 */
// export const convertYyyymmdd = param => {
//   let yyyymmdd = '';
//   const date = new Date(param);
//   if (param) {
//     yyyymmdd = `${String(date.getFullYear())}${String(date.getMonth() + 1).padStart(2, '0')}${String(
//       date.getDate(),
//     ).padStart(2, '0')}`;
//   }
//   return yyyymmdd;
// };

/**
 * 2024.10.09 - leejingyeong
 * 시간을 숫자로 변환하는 함수
 * @param {*} str 시간 문자열 ex) 21:00
 * @returns value 리턴 값
 */
export const convertHoursToNumber = (str) => {
  let value = '';
  if (str) {
    value = str.substring(0, 2);
    if (value !== '00') {
      value = value.replace(/^0+/, ''); // 문자열의 시작 부분에 있는 모든 0을 제거
    }
  }
  return parseInt(value);
};

/**
 * 2024.10.09 - leejingyeong
 * 숫자를 시간으로 변환하는 함수
 * @param {*} num
 *
 */
export const convertNumberToHours = (num) => {
  let value = '';
  if (num !== null && num !== undefined) {
    if (num === 0) {
      value = '00:00';
    } else {
      value = `${String(num).padStart(2, '0')}:00`;
    }
  }
  return value;
};

/**
 * 2024.10.09 - leejingyeong
 * 시간 범위에 속하는지 확인 하는 함수
 * @param {*} startTime 0~23 범위의 시간
 * @param {*} endTime 0~23 범위의 시간
 * @param {*} time 0~23 범위의 시간
 */
export const getIsTimeInRange = (startTime, endTime, time) => {
  let isInRange = false;
  if (startTime > endTime) {
    // 시작시간이 종료시간보다 큰 경우 (종료시간 < 시작시간)
    //현재 시간보다 시작시간이 크면서 현재시간보다 종료시간이 작은 경우에는 범위에 해당하지 않는다
    if (startTime > time && endTime <= time) {
      isInRange = false;
    }
    //현재 시간은 종료시간보다 크거나 같으며 혹은 시작시간보다 작거나 같아야 한다.
    else if (startTime >= time || endTime <= time) {
      isInRange = true;
    } else {
      isInRange = false;
    }
  } else if (startTime < endTime) {
    // 시작시간이 종료시간보다 작은 경우 (시작시간 < 종료시간)
    //시작시간과 종료시간이 현재 시간보다 작으면 범위에 해당하지 않는다.
    if (startTime < time && endTime <= time) {
      isInRange = false;
    }
    //시작시간과 종료시간이 현재 시간보다 크면 범위에 해당하지 않는다.
    else if (startTime > time && endTime > time) {
      isInRange = false;
    }
    //현재 시간은 시작시간보다 크거나 같으며 혹은 종료시간보다 작거나 같아야 한다.
    else if (startTime <= time || endTime >= time) {
      isInRange = true;
    } else {
      isInRange = false;
    }
  } else {
    //시작시간과 종료시간이 동일한 경우 (시작시간 == 종료시간)
    if (startTime === endTime) {
      isInRange = true;
    }
  }
  return isInRange;
};

/**
 * 2024.10.09 - leejingyeong
 * 비디오 업로드를 할 수 있는지 게시판 타입을 확인하는 함수
 */
export const checkVideoUploadBoardType = (param) => {
  let result = false;
  if (param) {
    // videoAllowedBoardTypes - 2: 교육자료, 7: 기술공유방 5: 일반문의, 6: 기술공지
    result = videoAllowedBoardTypes.includes(param);
  }
  return result;
};

export const getExtension = (fileName) => {
  parts = fileName.split('.');
  return parts.length > 1 ? parts.pop() : '';
};

/**
 * 2024.10.10 - leejingyeong
 * Date 유형에서 YYYY-MM-DD 유형으로 변경
 */
export const formatYyyymmddByDate = (date) => {
  let yyyymmdd = '';
  if (date) {
    yyyymmdd = `${String(date.getFullYear())}-${String(
      date.getMonth() + 1
    ).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  }
  return yyyymmdd;
};

/**
 *
 * @param {*} date
 * @returns
 */
export const formatYyyymm = (yyyymm) => {
  return /^\d{6}$/.test(yyyymm)
    ? yyyymm.replace(/(\d{4})(\d{2})/, '$1-$2')
    : yyyymm;
};
/**
 * 2024.10.09 - leejingyeong
 * 오늘로부터 특정 일자 전 일자까지 구하는 함수
 * format: YYYYMMDD (2024-10-01)
 */
export const getDateDaysAgo = (agoDay) => {
  let date = new Date();
  // if (agoDay && typeof agoDay === 'number') {
  date.setDate(date.getDate() - agoDay);
  // }

  return formatYyyymmddByDate(date);
};

/**
 * 2024.10.09 - leejingyeong
 * alarmLevel에 따른 class 할당
 */
export const assignClassAlarmLevel = (value) => {
  let classname = '';
  // [alarmLevel] 1:정상, 2:주의, 3:경고, 4:심각, 5:끊김, 6:이상, 7:안됨
  switch (value) {
    case 2:
      classname = 'caution prd'; // 2: 주의
      break;
    case 3:
      classname = 'warning prd'; // 3: 경고
      break;
    case 4:
      classname = 'serious prd'; // 4: 심각
      break;
    case 5:
      classname = 'inactive commu'; // 5: 끊김
      break;
    case 6:
      classname = 'warning commu'; // 6: 이상
      break;
    case 7:
      classname = 'serious commu'; // 7: 안됨
      break;
    default:
      classname = 'normal prd'; // 1: 정상
      break;
  }
  return classname;
};

/**
 * 2024.10.09 - leejingyeong
 * 알람레벨 별 색상 구하는 함수 (css 참고)
 * @param {*} alarmLevel
 * @returns
 */
export const assignColorByAlarmLevel = (alarmLevel) => {
  let color = '';
  // [alarmLevel] 1:정상, 2:주의, 3:경고, 4:심각, 5:끊김, 6:이상, 7:안됨
  switch (alarmLevel) {
    case 2:
      color = '#F5C000'; // 2: 주의(yellow)
      break;
    case 3:
      color = '#F69037'; // 3: 경고(orange)
      break;
    case 4:
      color = '#E45538'; // 4: 심각(red)
      break;
    case 5:
      color = '#7E92A9'; // 5: 끊김(commu-1)
      break;
    case 6:
      color = '#3A528A'; // 6: 이상(commu-2)
      break;
    case 7:
      color = '#072775'; // 7: 안됨(commu-3)
      break;
    case 8:
      color = '#4c4286'; // 8: 위험(purple)
      break;
    default:
      color = '#2BA196'; // 1: 정상(green)
      break;
  }
  return color;
};

/**
 * 2024.10.09 - leejingyeong
 * 월-일 양식 데이터 구하기
 * @param {*} date
 * @returns
 */
export const getMonthDashDateFormat = async (date) => {
  let formattedData;
  if (date instanceof Date) {
    formattedData = `${String(date.getMonth() + 1).padStart(2, '0')}-${String(
      date.getDate()
    ).padStart(2, '0')}`;
  }
  return formattedData;
};

/**
 * 2024.10.09 - leejingyeong
 * HH:mm:ss 시간 포맷 구하는 함수
 * @param {*} date
 * @returns
 */
export const getHHmmss = (date) => {
  let formattedData;
  if (date instanceof Date) {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    formattedData = `${hours}:${minutes}:${seconds}`;
  }
  return formattedData;
};

/**
 * 엔터키 눌렀을 때 중복 입력 방지를 위한 함수 (ios)
 * @param {*} e
 * @param {*} callback
 * @returns
 */
export const handleEnter = async (e, callback) => {
  if (e.isComposing) {
    // 한글 입력 시 중복 요청 방지
    return;
  }
  if (e.key === 'Enter') {
    callback();
  }
};

/**
 * 2024.11.08 - jslee
 * 배열 데이터 csv로 변환
 */
export const convertToCSV = (data) => {
  return data.map((row) => row.map((cell) => `"${cell}"`).join(',')).join('\n');
};

export const checkNormal = (value) => {
  let text = '';
  if (value !== null && value !== undefined) {
    if (value === false) {
      text = '정상';
    } else {
      text = '이상';
    }
  }
  return text;
};

/**
 * 2024.12.12. leejingyeong
 * null, undefined가 아닌 유효한 값인 경우 특정 문자열을 덧붙이는 함수
 * @param {*} value
 */
export const appendIfNotNull = (value, str) => {
  let text = '';
  if (value !== null && value !== undefined) {
    text = `${value}${str}`;
  }
  return text;
};

/**
 *
 * @param {*} value
 * @returns
 */
export const checkIsHigh = (value) => {
  let text = '';
  if (value !== null && value !== undefined) {
    if (value === true) {
      text = '높음';
    } else {
      text = '낮음';
    }
  }
  return text;
};

export const checkIsMaster = (value) => {
  let text = '';
  if (value !== null && value !== undefined) {
    if (value === false) {
      text = 'Master';
    } else {
      text = 'Slave';
    }
  }
  return text;
};

export const checkIsError = (value) => {
  let text = '';
  if (value !== null && value !== undefined) {
    if (value === '0') {
      text = '정상';
    } else {
      text = '에러';
    }
  }
  return text;
};

/**
 * 2024.12.18. leejingyeong
 * 알람레벨 별 컬러 구해오기
 */
export const getColorByAlarmLevel = (level) => {
  let color = '#2BA196'; // 정상
  switch (level) {
    case 2: // 주의
      color = '#F5C000';
      break;
    case 3: // 경고
      color = '#F69037';
      break;
    case 4: // 심각
      color = '#E45538';
      break;
    case 5: // 끊김
      color = '#7E92A9';
      break;
    case 8: // 위험
      color = '#4c4286';
      break;
    default:
      color = '#2BA196';
      break;
  }
  return color;
};

/**
 *
 * @param {*} value
 * @returns
 */
export const checkIsOnOff = (value) => {
  let text = '';
  if (value !== null && value !== undefined) {
    if (value === true) {
      text = 'ON';
    } else {
      text = 'OFF';
    }
  }
  return text;
};

/**
 * 2024.12.26. leejingyeong
 * 시작년도부터 해당 년까지 조회
 */
export const getYearsInRange = (startYearStr, endYearStr) => {
  let years = [];
  const startYear = parseInt(startYearStr);
  const endYear = parseInt(endYearStr);

  if (endYear >= startYear) {
    //2024-2027 3 [2024,2025,2026,2027]
    const yearCnt = endYear - startYear;
    for (let i = 0; i <= yearCnt; i++) {
      const year = startYear + i;
      years.push(year);
    }
  }
  return years;
};

/**
 * 2024.12.26. leejingyeong
 * 조회 가능 월 조회
 * @param {*} isLimitedCurrentMonth 현재월까지
 * @returns
 */
export const getMonths = (isLimitedCurrentMonth, year) => {
  let months = [];
  // 기본 세팅은 12월까지 보여주되 만약 isLimitedCurrentMonth가 참인 경우 현재년에 해당되면 현재년의 월까지만 보여져야 한다.
  if (isLimitedCurrentMonth === true) {
    if (year === parseInt(new Date().getFullYear())) {
      // 3월이면 3월까지만 보여지기
      for (let i = 1; i <= parseInt(new Date().getMonth()) + 1; i++) {
        months.push(i);
      }
    } else {
      for (let i = 1; i <= 12; i++) {
        months.push(i);
      }
    }
  } else {
    for (let i = 1; i <= 12; i++) {
      months.push(i);
    }
  }
  return months;
};

/**
 * 2024.01.03. leejingyeong.lee
 * 숫자 - 3자리 단위로 ',' 포맷
 * @param {*} number
 * @returns
 */
export const formatNumber = (number) => {
  if (!nullCheck(number) && typeof number === 'number') {
    return number.toLocaleString('en-US');
  } else {
    return number;
  }
};

/**
 * 2024.01.03. leejingyeong.lee
 * 암호화 된 전화번호 복호화 후 전화번호 양식으로 리턴하는 함수
 * @param {*} param
 * @returns
 */
export const getTelno = (param) => {
  let result = '';
  if (param) {
    const plain = securityInfo.decryptAes(param);
    if (plain !== '') {
      result = formatTelno(plain);
    } else {
      result = param;
    }
  }
  return result;
};

export const getUrlLang = (defaultLang) => {
  const path = window.location.pathname; // 예: "/ko/login" 또는 "/en/login"
  const firstPathSegment = path.split('/')[1];
  let lang = defaultLang;

  // https://cumongol.crksquare.com (영어 기본)
  // https://crksquare.com (한국어 기본)

  if (firstPathSegment === 'ko') {
    lang = 'ko';
  } else if (firstPathSegment === 'en') {
    lang = 'en';
  }

  return lang;
};

/**
 * 라우터경로 이동시킬 url 변경해서 리턴하는 함수
 * @param {*} url
 * @returns
 */
export const getLangUrl = (url, lang) => {
  let langUrl = '';
  if (url) {
    if (!url.startsWith('/')) {
      url = '/' + url;
    }

    langUrl = '/' + getUrlLang(lang) + url;
  }
  return langUrl;
};

/**
 * store에 세팅된 현재 설정된 언어(다국어) 가져오기
 * @returns
 */
export const getLang = () => {
  return store.state.locales?.lang;
};

/**
 * 국가코드 정규화
 * - 언어코드(ko/kr)가 들어온 경우 KR로 보정
 */
export const normalizeCountryCode = (countryCode) => {
  if (countryCode == null || countryCode === '') {
    return countryCode;
  }
  const normalized = String(countryCode).trim().toUpperCase();
  if (normalized === 'KO' || normalized === 'KR') {
    return 'KR';
  }
  return normalized;
};

/**
 * 국가/지역 코드 (ISO 3166-1 alpha-2)
 * - 언어코드(ko/kr)가 locale에 잘못 저장된 경우 KR로 보정
 */
export const getLocale = () => {
  return normalizeCountryCode(store.state.locales?.locale);
};
export const getTimeZone = () => {
  return store.state.locales?.timeZone;
};

/**
 * 사용자 설정 언어별 메뉴명 가져오기
 *
 * 추후에 추가되는 언어 세팅할것
 */
export const getMenuNameByLang = (item) => {
  const lang = getLang();
  let menuName = item.menuName; // 기본: 한국어 메뉴명
  switch (lang) {
    case 'en':
      if (item.menuNameEn) {
        // 영문 메뉴명
        menuName = item.menuNameEn;
      }
      break;
    default:
      break;
  }
  return menuName;
};

/**
 * 첫번째 문자열 대문자화
 * @param {*} str
 * @returns
 */
export function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * 언어별 공통 selectbox label 조회
 *
 * 추후에 추가되는 언어 세팅할것
 * @param {*} item
 * @returns
 */
// export const getCommonSelectboxLabelByLang = (item) => {
//   const lang = getLang()
//   let codeName = item.codeName // 기본: 한국어 코드명
//   switch (lang) {
//       case 'en':
//           if(item.codeNameEn){ // 영문 코드명
//               codeName = item.codeNameEn
//           }
//           break;
//       default:
//           break;
//   }
//   return codeName

// }

/**
 * 언어별 공통 selectbox label 조회
 * @param {*} item
 * @param {*} columnName
 * @returns
 */
export const getSelectboxLabelByLang = (item, columnName, customLang) => {
  let lang = getLang();

  if (customLang) {
    lang = customLang;
  }
  let selectboxLabel = item[columnName]; // 기본: 한국어 코드명

  const capitalizedLang = capitalizeFirstLetter(lang);

  const currentConfigLocaleColumnName = `${columnName}${capitalizedLang}`;

  if (item[currentConfigLocaleColumnName]) {
    selectboxLabel = item[currentConfigLocaleColumnName];
  }

  return selectboxLabel;
};

/**
 * 도메인 기준별 기본 세팅 언어 가져오기
 */
export const getLangByNation = () => {
  let lang = 'ko';
  const hostData = hostConfig.find(
    (item) => item.url === window.location.origin
  );
  if (hostData) {
    const localeData = getLocaleConfigItem(hostData.locale);
    lang = localeData.useLangCode;
  }
  return lang;
};

/**
 * 도메인 기준별 기본 세팅 localeCode 가져오기
 * @returns
 */
export const getLocaleByNation = () => {
  let locale = 'KR';
  const hostData = hostConfig.find(
    (item) => item.url === window.location.origin
  );
  if (hostData) {
    const localeData = getLocaleConfigItem(hostData.locale);
    locale = localeData.localeCode;
  }
  return locale;
};

/**
 *
 * @returns
 */
export const getTimeZoneByNation = (localeParam) => {
  let timeZone = 'Asia/Seoul';
  const hostData = hostConfig.find(
    (item) => item.url === window.location.origin
  );
  if (hostData) {
    const localeData = getLocaleConfigItem(hostData.locale);
    timeZone = localeData.timeZone;
  }
  return timeZone;
};

/**
 * 라우터 이동
 * @param {*} url
 */
export const moveRouteUrl = (url) => {
  let lang = getLang();
  let path = `/${lang}/${url}`;
  // 선택한 언어가 없는 경우
  if (!lang) {
    // lang = getLangByNation() // TODO: 도메인 기준별 기본 세팅 언어를 가져온다.
    path = getLangUrl();
  }
  return path;
};

/**
 * YYYY-MM-DD HH:mm:ss 유형의 데이터를 utc 시간(ex: 1740025839000) 유형으로 전환한 뒤
 * 일수만큼 가감한 utc 시간 반환
 */
export const getCalculateUtcTimeStamp = (kstTimeString, days) => {
  const utcTimestamp = convertKSTToUTCTimestamp(kstTimeString);
  let dateTime = kstTimeString;

  if (utcTimestamp && days !== 0) {
    const daysMs = days * 24 * 60 * 60 * 1000;
    dateTime = utcTimestamp + daysMs;
  }
  return dateTime;
};

/**
 * YYYY-MM-DD HH:mm:ss 유형의 데이터를 utc 시간(ex: 1740025839000) 유형으로 전환한 뒤
 * 일수만큼 가감한 utc 시간을 다시 YYYY-MM-DD HH:mm:ss 유형의 데이터로 변경
 * @param {*} kstTimeString
 * @param {*} days
 * @returns
 */
export const getCalculateUtcFormattedTimeStamp = (kstTimeString, days) => {
  const utcTimestamp = convertKSTToUTCTimestamp(kstTimeString);
  let formattedDateTime = kstTimeString;
  if (utcTimestamp && days !== 0) {
    const daysMs = days * 24 * 60 * 60 * 1000;
    const timestamp = utcTimestamp + daysMs;
    formattedDateTime = convertUTCTimestampToTimeZoneTime(timestamp);
  }
  return formattedDateTime;
};

/**
 * YYYY-MM-DD HH:mm:ss 유형의 시간을 utc 시간(ex: 1740025839000) 유형으로 변경
 * @param {*} kstTimeString
 * @returns
 */
export const convertKSTToUTCTimestamp = (kstTimeString) => {
  // 입력값이 없는 경우 방어 코드 추가
  if (!kstTimeString || typeof kstTimeString !== 'string') {
    return null;
  }

  // 공백을 기준으로 날짜와 시간 분리
  const parts = kstTimeString.trim().split(' ');
  const date = parts[0]; // 날짜는 필수
  const time = parts[1] || '00:00:00'; // 시간이 없으면 00:00:00으로 기본 설정

  // 날짜가 유효한지 확인
  const dateParts = date.split('-').map(Number);
  const timeParts = time.split(':').map(Number);

  // 날짜와 시간이 숫자로 변환 가능한지 체크
  if (
    dateParts.length !== 3 ||
    timeParts.length !== 3 ||
    dateParts.some(isNaN) ||
    timeParts.some(isNaN)
  ) {
    // console.error("Invalid date/time values:", kstTimeString);
    return null;
  }

  const [year, month, day] = dateParts;
  const [hour, minute, second] = timeParts;

  // UTC 기준 타임스탬프 (한국 시간에서 9시간 빼기. DB 타임존 시간이 한국으로 되어있음)
  const utcTimestamp = Date.UTC(year, month - 1, day, hour - 9, minute, second);

  return utcTimestamp;
};

/**
 * utc 시간(ex: 1740025839000)을 YYYY-MM-DD HH:mm:ss 유형으로 변경
 * @param {*} utcTimestamp
 * @returns
 */
export const convertUTCTimestampToTimeZoneTime = (utcTimestamp) => {
  if (!utcTimestamp) return null;

  const timeZone = getTimeZone() || 'Asia/Seoul';

  const options = {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false, // 24시간 형식 유지
  };

  const formatter = new Intl.DateTimeFormat('en-US', options);
  const parts = formatter.formatToParts(new Date(utcTimestamp));

  // 날짜 및 시간 조각을 추출하여 포맷 변환
  const year = parts.find((p) => p.type === 'year').value;
  const month = parts.find((p) => p.type === 'month').value;
  const day = parts.find((p) => p.type === 'day').value;
  const hour = parts.find((p) => p.type === 'hour').value;
  const minute = parts.find((p) => p.type === 'minute').value;
  const second = parts.find((p) => p.type === 'second').value;

  return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
};

/**
 * 지정한 Timezone 시간 구하기
 * @param {*} param
 * @returns
 */
export const getTimeInTimeZone = (param) => {
  if (param) {
    const utcTime = convertKSTToUTCTimestamp(param);
    return convertUTCTimestampToTimeZoneTime(utcTime);

    // const [date, time] = param.split(" ");
    // //2025-02-18 dokyung.lee - 현재 DB 타임존이 한국이기 때문에 param값을 한국시간대임을 표현 -> os설정된 타임존에 맞춰 Date객체 생성 하여 store의 타임존에 해당하는 시간으로 변경 - db 타임존 변경 시 해당 타임존으로 포맷변경필요함
    // const koreanTime = new Date(`${date}T${time}+09:00`);
    // const options = {
    //   timeZone: getTimeZone() || "Asia/Seoul",
    //   year: "numeric",
    //   month: "2-digit",
    //   day: "2-digit",
    //   hour: "2-digit",
    //   minute: "2-digit",
    //   second: "2-digit",
    // };

    // const timeInTimeZone = new Intl.DateTimeFormat("en-GB", options)
    //   .format(koreanTime)
    //   .replace(",", "")
    //   .replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$2-$1"); // 포맷 변경
    //   return timeInTimeZone
  }

  return param;
};

export const getCurrentTimeInTimeZone = (param) => {
  if (param) {
    const time = new Date(param);
    const options = {
      timeZone: getTimeZone() || 'Asia/Seoul',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    };

    const timeInTimeZone = new Intl.DateTimeFormat('en-GB', options)
      .format(time)
      .replace(',', '')
      .replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1'); // 포맷 변경
    return timeInTimeZone;
  }

  return param;
};

/**
 * YYYY-MM-DD hh:mm:ss 양식의 문자열 데이터를 mm dd 추출
 * @param {*} dateString
 * @returns
 */
export const formatMonthDate = (dateString) => {
  const [datePart] = dateString.split(' '); // 날짜와 시간 분리
  const [year, month, day] = datePart.split('-'); // 연, 월, 일 분리

  return `${month} ${day}`;
};

/**
 * YYYY-MM-DD hh:mm:ss 양식의 문자열 데이터를 dd hh:mm 양식 추출
 * @param {*} dateString
 * @returns
 */
export const formatDateTime = (dateString) => {
  const [datePart, timePart] = dateString.split(' ');
  const [year, month, day] = datePart.split('-');
  const [hours, minutes] = timePart.split(':');

  return `${day} ${hours}:${minutes}`;
};

export const getLocaleConfigItem = (locale) => {
  let result = {};
  if (locale) {
    result = localeConfig.find((item) => item.localeCode === locale);
  }
  return result;
};

export const getFileSizeText = (fileSize) => {
  let result = '';
  if (fileSize) {
    if (fileSize >= 1024 * 1024 * 1024) {
      // GB 이상일 때
      const sizeInGB = fileSize / (1024 * 1024 * 1024);
      result = Number.isInteger(sizeInGB)
        ? `${sizeInGB} GB`
        : `${Math.floor(sizeInGB * 10) / 10} GB`; // 한 자리 소수점으로 버림 처리
    } else if (fileSize >= 1024 * 1024) {
      // MB 이상일 때
      const sizeInMB = fileSize / (1024 * 1024);
      result = Number.isInteger(sizeInMB)
        ? `${sizeInMB} MB`
        : `${Math.floor(sizeInMB * 10) / 10} MB`; // 한 자리 소수점으로 버림 처리
    } else if (fileSize >= 1024) {
      // KB 이상일 때
      const sizeInKB = fileSize / 1024;
      result = Number.isInteger(sizeInKB)
        ? `${sizeInKB} KB`
        : `${Math.floor(sizeInKB * 10) / 10} KB`; // 한 자리 소수점으로 버림 처리
    } else {
      // Byte일 때
      result = `${fileSize} B`;
    }
  }
  return result;
};

/**
 * 특정한 요소의 행을 0번쨰 행으로 이동
 */
export const moveToFirst = (arr, conditionFn) => {
  const index = arr.findIndex(conditionFn);
  if (index !== -1) {
    const [item] = arr.splice(index, 1);
    arr.unshift(item);
  }
  return arr;
};

/**
 *
 * @param {*} startMonth  시작월
 * @param {*} endMonth  종료월
 * @param {*} minRangeMonth  최소월
 * @param {*} maxRangeMonth  최대월
 * @returns
 */
export const isInvalidRangeMonth = (
  startMonth,
  endMonth,
  minRangeMonth,
  maxRangeMonth
) => {
  if (!startMonth || !endMonth) return false;

  const startYear = parseInt(startMonth.substring(0, 4));
  const startMonthNum = parseInt(startMonth.substring(5, 7));

  const endYear = parseInt(endMonth.substring(0, 4));
  const endMonthNum = parseInt(endMonth.substring(5, 7));

  // 년도와 월을 기준으로 개월 수 계산
  const monthDiff = (endYear - startYear) * 12 + (endMonthNum - startMonthNum);
  return (
    monthDiff != 0 && (monthDiff > maxRangeMonth || monthDiff < minRangeMonth)
  ); // 최대 개월보다 크거나 최소 개월보다 작은 경우에 true
};

export const replaceStartWiwthZero = (number) => {
  return number.startsWith('0') ? number.replace(/^0+/, '') : number;
};

/**
 * 전화번호 포맷팅 함수
 * 01012345678 -> 010-1234-5678
 * 0212345678 -> 02-1234-5678
 * 15881234 -> 1588-1234
 * @param {string} phoneNumber - 포맷팅할 전화번호
 * @returns {string} - 포맷팅된 전화번호
 */
export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return phoneNumber;

  // 숫자만 추출
  const numbers = phoneNumber.replace(/[^0-9]/g, '');

  if (numbers.length === 0) return phoneNumber;

  // 휴대폰 번호 (010, 011, 016, 017, 018, 019)
  if (numbers.match(/^01[0-9]/)) {
    if (numbers.length === 11) {
      return numbers.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    } else if (numbers.length === 10) {
      return numbers.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    }
  }
  // 서울 지역번호 (02)
  else if (numbers.match(/^02/)) {
    if (numbers.length === 9) {
      return numbers.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
    } else if (numbers.length === 10) {
      return numbers.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
    }
  }
  // 기타 지역번호 (031, 032, 033, 041, 042, 043, 051, 052, 053, 054, 055, 061, 062, 063, 064)
  else if (numbers.match(/^0[3-9][0-9]/)) {
    if (numbers.length === 10) {
      return numbers.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    } else if (numbers.length === 11) {
      return numbers.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    }
  }
  // 특수번호 (1588, 1577, 1566, 080 등)
  else if (numbers.match(/^1[0-9]{3}/) || numbers.match(/^080/)) {
    if (numbers.length === 8) {
      return numbers.replace(/(\d{4})(\d{4})/, '$1-$2');
    }
  }

  // 기본 포맷 (위 조건에 맞지 않는 경우)
  return phoneNumber;
};

/**
 * store_contract 등 API 기간 문자열에서 종료일(로컬 자정 기준).
 * "YYYY-MM-DD ~ YYYY-MM-DD" 또는 단일 "YYYY-MM-DD"
 * @param {string|null|undefined} periodStr
 * @returns {Date|null}
 */
export const parseContractPeriodEndDate = (periodStr) => {
  if (periodStr == null) return null;
  const trim = String(periodStr).trim();
  if (!trim) return null;
  const parts = trim.split(/\s*~\s*/).map((p) => p.trim()).filter(Boolean);
  const endDateStr = parts.length >= 2 ? parts[parts.length - 1] : parts[0];
  if (!endDateStr) return null;
  const m = endDateStr.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return null;
  return new Date(
    parseInt(m[1], 10),
    parseInt(m[2], 10) - 1,
    parseInt(m[3], 10)
  );
};

/**
 * 오늘(로컬 자정)부터 계약 종료일까지 남은 일수. 파싱 불가 시 null.
 * 종료일 당일 = 0, 이후는 음수.
 * @param {string|null|undefined} periodStr
 * @returns {number|null}
 */
export const getCalendarDaysUntilContractEnd = (periodStr) => {
  const end = parseContractPeriodEndDate(periodStr);
  if (!end) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const endDay = new Date(end);
  endDay.setHours(0, 0, 0, 0);
  return Math.round((endDay - today) / (24 * 60 * 60 * 1000));
};
